import { nanoid } from 'nanoid';

import { AsyncActionStatus } from '../enums';

export const makeActionCreator = (type, argNames = []) => (...args) => {
  const action = { type, payload: {} };
  argNames.forEach((argName, index) => (action.payload[argName] = args[index]));
  return action;
};

export const makeAsyncActionCreators = (
  asyncTypes,
  pendingArgNames = [],
  fulfilledArgNames = [],
  rejectedArgNames = ['error'],
) => {
  const meta = { requestId: nanoid(21) };

  return {
    [AsyncActionStatus.PENDING]: (...args) => {
      const action = {
        type: asyncTypes[AsyncActionStatus.PENDING],
        payload: {},
        meta,
      };
      pendingArgNames.forEach((argName, index) => (action.payload[argName] = args[index]));
      return action;
    },
    [AsyncActionStatus.FULFILLED]: (...args) => {
      const action = {
        type: asyncTypes[AsyncActionStatus.FULFILLED],
        payload: {},
        meta,
      };
      fulfilledArgNames.forEach((argName, index) => (action.payload[argName] = args[index]));
      return action;
    },
    [AsyncActionStatus.REJECTED]: (...args) => {
      const action = {
        type: asyncTypes[AsyncActionStatus.REJECTED],
        meta,
      };
      rejectedArgNames.forEach((argName, index) => (action[argName] = args[index]));
      return action;
    },
  };
};
